import {TimeSpan} from "@sparkware/app-utils";

export enum TSR_TYPE {
    SESSION_TIMER,
    GAME_TIMER
}

export type ITimeSpentReminderOptions = ISessionTimeSpentReminderComponentProps | IGameTimeSpentReminderComponentProps;

export interface ITimeSpentReminderComponentBaseProps {
    playingTime: TimeSpan;
}

interface ISessionTimeSpentReminderComponentProps extends ITimeSpentReminderComponentBaseProps {
    timerType: TSR_TYPE.SESSION_TIMER;
}

interface IGameTimeSpentReminderComponentProps extends ITimeSpentReminderComponentBaseProps {
    timerType: TSR_TYPE.GAME_TIMER;
    onStopReminders: () => void;
}

export interface ITimeSpentReminderWithBalanceComponentProps extends ITimeSpentReminderComponentBaseProps {
    totalNetLoss: number;
    isInGame: boolean;
}